import React, { useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Login } from './components/Login';
import { ChatWindow } from './components/Chat/ChatWindow';
import { chatService } from './services/chatService';
import { isConfigured } from './services/firebase';
import { Loader2, AlertTriangle, FileCode } from 'lucide-react';

const AppContent: React.FC = () => {
  const { user, loading, isLoggingOut } = useAuth();

  useEffect(() => {
    if (user) {
      chatService.initNotepad();
    }
  }, [user]);

  if (isLoggingOut) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-10 h-10 text-red-500 animate-spin" />
          <p className="text-gray-500 font-medium">Logging out...</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="w-10 h-10 text-blue-600 animate-spin" />
          <p className="text-gray-500 font-medium">Connecting to Firebase...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return <ChatWindow currentUser={user} />;
};

const App: React.FC = () => {
  if (!isConfigured) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 p-4">
        <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-8 text-center space-y-6">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto">
            <AlertTriangle className="w-8 h-8 text-amber-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Setup Required</h1>
            <p className="text-gray-500 mt-2">The application is not connected to Firebase.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
